import PublicLayout from "../components/PublicLayout";
import { Scale, ShieldAlert, Award, FileText } from "lucide-react";

export default function TermsPage() {
    return (
        <PublicLayout>
            <div className="max-w-[800px] mx-auto px-6 py-16">
                
                {/* Title */}
                <div className="border-b border-[#27272A] pb-6 mb-10">
                    <div className="label-mono text-[#00FF41] mb-2">// agreements / legal</div>
                    <h1 className="text-3xl font-display font-black tracking-tight text-[#FAFAFA] uppercase">
                        TERMS OF SERVICE
                    </h1>
                    <p className="text-[#A1A1AA] text-xs font-mono mt-1 uppercase">
                        Last Updated: June 4, 2026
                    </p>
                </div>

                {/* Core Sections */}
                <div className="space-y-10 text-xs md:text-sm text-[#A1A1AA] leading-relaxed">
                    
                    {/* Intro */}
                    <p>
                        Welcome to SynapseLink. By creating an account, installing the `slink` executable, or proxying traffic through our gateway relays, you agree to comply with and be bound by the following Terms of Service.
                    </p>

                    {/* Section 1: Acceptable Use Policy */}
                    <div className="border border-[#27272A] bg-[#0A0A0A] p-6">
                        <div className="flex items-center gap-2 text-[#FAFAFA] font-bold uppercase mb-3">
                            <ShieldAlert className="w-5 h-5 text-[#FF9900]" />
                            <span>1. Fair Use & Prohibited Conduct</span>
                        </div>
                        <p>
                            Tunnels are intended to expose local applications for development, integration, webhook testing, or internal demonstrations. You agree not to use SynapseLink to:
                        </p>
                        <ul className="list-disc list-inside space-y-2 mt-2 pl-2">
                            <li>Distribute malicious software, botnets, or command and control servers.</li>
                            <li>Run phishing campaigns, duplicate deceptive login portals, or host illegal content.</li>
                            <li>Exceed limits defined by your subscription tier (DDoS patterns or spam networks).</li>
                        </ul>
                        <p className="mt-2 text-[#FF9900] italic text-[11px]">
                            Violation of this section results in immediate and permanent account suspension.
                        </p>
                    </div>

                    {/* Section 2: Quota Allowances */}
                    <div>
                        <h2 className="text-sm font-bold text-[#FAFAFA] uppercase mb-3 flex items-center gap-2">
                            <Award className="w-4 h-4 text-[#00FF41]" />
                            2. Tiers & Resource Allocations
                        </h2>
                        <p>
                            We allocate bandwidth and daily requests based on your plan limits:
                        </p>
                        <ul className="list-disc list-inside space-y-1 mt-2 pl-2">
                            <li>**Free Tier**: 1 tunnel, random subdomains, 500 requests per day.</li>
                            <li>**Pro Tier**: 5 tunnels, custom subdomains, custom domains, 50,000 requests per day.</li>
                            <li>**Enterprise Tier**: 100 tunnels, unlimited custom domains, SLA support, 5,000,000 requests per day.</li>
                        </ul>
                        <p className="mt-2">
                            If you hit a plan quota, incoming traffic will receive HTTP 429 warnings until the daily allocation resets or you choose to upgrade your plan.
                        </p>
                    </div>

                    {/* Section 3: Disclaimer of Warranty */}
                    <div>
                        <h2 className="text-sm font-bold text-[#FAFAFA] uppercase mb-3 flex items-center gap-2">
                            <Scale className="w-4 h-4 text-[#00FF41]" />
                            3. Limitation of Liability
                        </h2>
                        <p>
                            SynapseLink is provided "as is" and "as available". We do not warrant that our relays will be uninterrupted or error-free. We are not liable for direct, indirect, or consequential damages resulting from connection failures, data leaks, server exposure, or database sync errors.
                        </p>
                    </div>

                    {/* Section 4: Term Modifications */}
                    <div>
                        <h2 className="text-sm font-bold text-[#FAFAFA] uppercase mb-3 flex items-center gap-2">
                            <FileText className="w-4 h-4 text-[#00FF41]" />
                            4. Modifying the Terms
                        </h2>
                        <p>
                            We reserve the right to adapt or replace these terms at any time. When updates are published, we will notify users through this page or account alerts.
                        </p>
                    </div>

                </div>

            </div>
        </PublicLayout>
    );
}
